"use client";

import PropTypes from 'prop-types';
// @mui
import { alpha, styled } from '@mui/material/styles';
import { Tooltip } from '@mui/material';
// utils
import cssStyles from '../../../utils/cssStyles';
//
import Iconify from '../../Iconify';
import { IconButtonAnimate } from '../../animate';
import { useSelector } from 'react-redux'; // Import useSelector
import toast from 'react-hot-toast'; // Import toast
import { UserCircle } from 'phosphor-react'; // Import UserCircle icon

// ----------------------------------------------------------------------

const RootStyle = styled('span')(({ theme }) => ({
  ...cssStyles(theme).bgBlur({ opacity: 0.64 }),
  right: 0,
  top: '50%',
  position: 'fixed',
  marginTop: theme.spacing(-3),
  padding: theme.spacing(0.5),
  zIndex: theme.zIndex.drawer + 2,
  borderRadius: '24px 0 20px 24px',
  boxShadow: `-12px 12px 32px -4px ${alpha(
    theme.palette.mode === 'light' ? theme.palette.grey[600] : theme.palette.common.black,
    0.36
  )}`,
}));

const DotStyle = styled('span')(({ theme }) => ({
  top: 8,
  width: 8,
  height: 8,
  right: 10,
  borderRadius: '50%',
  position: 'absolute',
  backgroundColor: theme.palette.error.main,
}));

// ----------------------------------------------------------------------

ToggleButton.propTypes = {
  notDefault: PropTypes.bool,
  onToggle: PropTypes.func,
  open: PropTypes.bool,
};

export default function ToggleButton({ notDefault, open, onToggle }) {
  const { selectedChatId, chatParams } = useSelector((state) => state.app); // Get selectedChatId and chatParams


 

  const handleToggleClick = () => {
    // Removed the toast notification as requested.
    onToggle(); // Call the original toggle function
    
  };

  return (
    <RootStyle>
      {notDefault && !open && <DotStyle />}

      <Tooltip title="Patient Info" placement="left"> {/* Changed tooltip text here */}
        <IconButtonAnimate
          color="inherit"
          onClick={handleToggleClick} // Use the new handler
          sx={{
            p: 1.25,
            transition: (theme) => theme.transitions.create('all'),
            '&:hover': {
              color: 'primary.main',
              bgcolor: (theme) => alpha(theme.palette.primary.main, theme.palette.action.hoverOpacity),
            },
          }}
        >
          <UserCircle size={20} /> {/* Changed icon here */}
        </IconButtonAnimate>
      </Tooltip>
    </RootStyle>
  );
}